<template>
    <m-input :active="focus" @click="setFocus()" :error="error">
        <input class="w-full outline-none p-1" :autocomplete="newpassword ? 'new-password' : true" v-model="model"
               :type="preview ? 'text' : 'password'" @focus="updateFocus(true)" @blur="updateFocus(false)" ref="input"
               @input="handleInput" @keydown.enter="$emit('enter')" :class="this.bottom ? 'border-b' : 'border'"/>
        <slot></slot>
        <div slot="icon" :class="preview ? 'sprite-icons-nopreview' : 'sprite-icons-preview'"
             @click="previewClicked"></div>
    </m-input>
</template>
<script>
export default {
    props: {
        value: String,
        error: {
            type: Boolean,
            default: false
        },
        bottom: {
            type: Boolean,
            default: false
        },
        newpassword: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        // detect external change
        value(newval) {
            this.model = newval
        }
    },
    data() {
        return {
            model: this.value,
            focus: false,
            preview: false
        };
    },
    methods: {
        previewClicked() {
            this.preview = !this.preview;
        },
        updateFocus(state) {
            this.focus = state
            this.$emit('focus', state)
        },
        handleInput() {
            this.$emit('input', this.model)
        },
        setFocus() {
            this.$refs.input.focus();
        }
    }
};
</script>